import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import styled from 'styled-components';
import { dottedLinkStyles } from '@components/Link';
import {
  HEIGHT,
  HEIGHT_MOBILE,
  HEIGHT_MOBILE_MIN,
  WIDTH_BODY,
  WIDTH_BODY_MOBILE,
  WIDTH_BODY_XL,
  WIDTH_TITLE,
  WIDTH_TITLE_MOBILE,
  WIDTH_TITLE_XL,
} from './ContactCollectorSection.constants';

export const StyledSection = styled(Flex)`
  height: ${HEIGHT};
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: auto;
    min-height: auto;
    flex-direction: column;
    padding: ${themeSpace(10)} ${themeSpace(7)} ${themeSpace(8)};
  }
  ${themeMediaQuery('mobile')} {
    padding: ${themeSpace(8)} ${themeSpace(6)} ${themeSpace(6)};
    margin-bottom: ${themeSpace(5)} !important;
  }
  ${themeMediaQuery('tablet')} {
    img {
      object-position: bottom;
    }
    iframe {
      padding-bottom: 50vh;
    }
  }
`;

export const TextContainer = styled(Flex)`
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: flex-start;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    height: auto;
  }
  ${themeMediaQuery('sm')} {
    margin-top: 0;
    align-items: center;
  }
`;

export const LottieContainer = styled(Flex)`
  padding: 0px ${themeSpace(6)};
  width: 100%;
  min-height: 100%;
  ${themeMediaQuery('below_sm')} {
    padding: 0;
    min-height: auto;
  }
  ${themeMediaQuery('sm')} {
    width: fit-content;
    transform: scale(0.9);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
    padding: 0px ${themeSpace(12)};
  }
`;

export const EyebrowWrapper = styled(Flex)`
  align-items: flex-end;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    justify-content: center;
    /* Override NewFlag's internal flex-direction for mobile */
    > div {
      flex-direction: row;
      align-items: center;
    }
  }
  ${themeMediaQuery('mobile')} {
    margin-bottom: ${themeSpace(3)};
    /* Remove gap and reduce eyebrow size */
    > div {
      gap: 0;
    }
    span {
      ${themeVariant('sectionEyeBrow16')};
    }
  }
`;

export const StyledText = styled(Text)`
  position: relative;
  bottom: ${themeSpace(5)};
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 432px;
    margin-bottom: ${themeSpace(5)};
    ${themeVariant('calloutHed28')}
  }
  .text-pairing-body {
    max-width: 432px;
    ${themeVariant('featureCopy16')}
  }
  ${themeMediaQuery('mobile')} {
    .text-pairing-title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: ${themeSpace(3)};
    }
  }
  ${themeMediaQuery('lg')} {
    .text-pairing-title {
      max-width: 502px;
      ${themeVariant('calloutHed32')}
    }
    .text-pairing-body {
      max-width: 502px;
      ${themeVariant('featureCopy17')}
    }
  }
`;

export const CollectAddressButton = styled(Button)`
  height: ${themeSpace(8)};
  border-width: 2px;
  ${themeMediaQuery('sm')} {
    height: ${themeSpace(9)};
    border-width: 2px;
  }
`;

export const LearnMoreButton = styled(Button)`
  height: ${themeSpace(8)};
  ${themeMediaQuery('below_sm')} {
    ${dottedLinkStyles}
    color: ${themeColor('mono1')};
    height: auto;
    padding: 0;
    background: transparent;
    border: none;
    /* Hide the chevron icon for dotted link style */
    svg {
      display: none;
    }
  }
  ${themeMediaQuery('sm')} {
    height: ${themeSpace(9)};
  }
`;

export const ButtonWrapper = styled(Flex)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${themeSpace(6)};
`;

export const VideoContainer = styled.div`
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    margin-top: ${themeSpace(6)};
    width: 100%;
    aspect-ratio: 16 / 10;
    border-radius: 16px;
    overflow: hidden;
    /* Ensure VimeoVideo fills container properly */
    > div {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center bottom;
      position: relative !important;
      top: auto !important;
      left: auto !important;
      transform: none !important;
    }
  }
  ${themeMediaQuery('mobile')} {
    margin-top: ${themeSpace(4)}; /* 12px for tighter spacing */
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
`;
